module.exports = __webpack_public_path__ + "img/USDC-icon.0a13861a.svg";